export type WorkflowStatus = "可用" | "草稿" | "已归档";

export interface WorkflowItem {
  id: string;
  title: string;
  subject: string;
  status: WorkflowStatus;
  description: string;
  updatedAt: string;
  coverType: "wire" | "doc" | "image";
}

export const workflowSubjects = [
  "材料科学",
  "生物工程",
  "量子物理",
  "信号处理",
  "催化化学",
] as const;

export const workflowStatusList: WorkflowStatus[] = ["可用", "草稿", "已归档"];

export const workflowsData: WorkflowItem[] = [
  {
    id: "wf_hea",
    title: "HEA 催化剂逆向设计与筛选工作流",
    subject: "材料科学",
    status: "可用",
    description:
      "面向 HER 催化的高熵合金（HEA）自动化发现：元素池/约束 → 候选生成 → NNP/ML 快速筛 → 少量 DFT 校准 → 多目标排序 → 输出 Top-K + 实验建议与报告沉淀。",
    updatedAt: "2026-04-27 19:05",
    coverType: "wire",
  },
  {
    id: "wf1",
    title: "炼石者—ER工作流起点",
    subject: "材料科学",
    status: "可用",
    description: "输入元素池与约束条件，自动生成候选 HEA 组合并进入高通量筛选流程。",
    updatedAt: "2026-04-27 10:24",
    coverType: "wire",
  },
  {
    id: "wf2",
    title: "文献DOI深度提取工作流",
    subject: "信号处理",
    status: "草稿",
    description: "对 PDF/网页内容做结构化抽取，聚合 DOI、作者、年份与关键结论，生成可入库条目。",
    updatedAt: "2026-04-01 14:34",
    coverType: "doc",
  },
  {
    id: "wf3",
    title: "每日周报生成智能体工作流",
    subject: "生物工程",
    status: "可用",
    description: "从对话与任务记录生成日报/周报，自动归档到知识库并输出可分享的摘要。",
    updatedAt: "2026-04-11 09:07",
    coverType: "wire",
  },
  {
    id: "wf4",
    title: "测试工作流",
    subject: "量子物理",
    status: "已归档",
    description: "用于联调连线规则与节点库展示的基础工作流模板。",
    updatedAt: "2026-03-12 18:02",
    coverType: "image",
  },
];

